import { initialState } from 'src/contexts/settings/settings-context';
import { therapyPlanningAction } from '../../actions/constant';

const {
  GET_THERAPY_PLANNING_FAILURE,
  GET_THERAPY_PLANNING_SUCCESS,
  GET_THERAPY_PLANNING_CANCEL_TOKEN,
  GET_THERAPY_PLANNING_LOADING,
} = therapyPlanningAction;

const intitialstate: object = {
  isError: false,
  errorMessage: '',
  response: null,
  loading: false,
};

export const getTherapyPlanningReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_THERAPY_PLANNING_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        isError: false,
        errorMessage: '',
        loading: false,
      };
    }

    case GET_THERAPY_PLANNING_FAILURE:
      return {
        ...state,
        isError: true,
        errorMessage: action.paylod,
        response: null,
        loading: false,
      };
    case GET_THERAPY_PLANNING_CANCEL_TOKEN:
      return {
        ...state,
        isError: true,
        errorMessage: action.paylod,
        response: null,
      };
    case GET_THERAPY_PLANNING_LOADING:
      return {
        ...initialState,
        loading: true,
      };

    default:
      return state;
  }
};
